export class CrmAccount {
	public Id:string;
	public Name:string;

	constructor(o?:any) {
		Object.assign(this,o);
	}
}